import { BehaviorSubject, Observable } from 'rxjs'
import { Route } from '../../Types/Types'

// Subject for opening the menu.
const routerStateSubject: BehaviorSubject<Route[]> = new BehaviorSubject<Route[]>([])

// Observable for when to open the menu.
export const routerState$: Observable<Route[]> = routerStateSubject.asObservable()

// Announce when the menu should be opened.
export const announceRoute = (route: Route): void => routerStateSubject.next([...routerStateSubject.value, route])
